import React from "react"
import PropTypes from "prop-types"
import Markdown from "markdown-to-jsx"
import theme from "styles/theme"

const iconSizeDesktop = 110,
  iconSizeMobile = 85

const HighlightCard = ({
  className,
  iconType,
  iconLikeText,
  iconSvg,
  iconDesc,
}) => {
	return (
    <div
      className={className}
      css={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.white,
        borderBottom: `6px solid ${theme.midBlue}`,
        maxWidth: 360,
        margin: "0 auto",
        padding: "0 32px 20px",
        [theme.tablet]: {
          padding: "0 30px 20px",
        },
        [theme.mobile]: {
          padding: "0 20px 20px",
          borderBottomWidth: 5,
        },
      }}
    >
      <div
        css={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px 0 34px",
        }}
      >
        <div
          css={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: iconSizeDesktop,
            height: iconSizeDesktop,
            [theme.mobile]: {
              width: iconSizeMobile,
              height: iconSizeMobile,
            },
          }}
        >
          <Icon
            iconType={iconType}
            iconLikeText={iconLikeText}
            iconSvg={iconSvg}
          />
        </div>
      </div>
      <div
        css={{
          ...theme.highlightCardDesc,
          color: theme.darkGray,
          textAlign: "center",
        }}
      >
        {iconDesc}
      </div>
    </div>
  )
}

export default HighlightCard

HighlightCard.propTypes = {
  iconType: PropTypes.oneOf(["icon", "text"]).isRequired,
  iconLikeText: PropTypes.string,
  iconSvg: PropTypes.string,
  iconDesc: PropTypes.string.isRequired,
}

const Icon = ({
  iconType,
  iconLikeText,
  iconSvg,
}) => {
  if (iconType === "icon" && iconSvg) {
    return (
      <div
        css={{
          svg: {
            width: "100%",
            height: "100%",
            maxWidth: iconSizeDesktop,
            maxHeight: iconSizeDesktop,
            [theme.mobile]: {
              maxWidth: iconSizeMobile,
              maxHeight: iconSizeMobile,
            },
            path: {
              stroke: theme.midBlue,
            },
          },
        }}
      >
        <Markdown className="icon">{iconSvg}</Markdown>
      </div>
    )
  } else if (iconType === "text" && iconLikeText.trim()) {
    return (
      <div
        css={{
          ...theme.highlightCardIconLikeText,
          display: "inline-block",
          color: theme.midBlue,
          wordBreak: "keep-all",
        }}
      >
        {iconLikeText}
      </div>
    )
  }
  return ""
}
